import { render, staticRenderFns } from "./folderTargetsPopover.vue?vue&type=template&id=25a2c1b4&"
import script from "./folderTargetsPopover.vue?vue&type=script&lang=js&"
export * from "./folderTargetsPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports